import moment from 'moment';
import Vue from 'vue';

export default {
  methods: {
    generateDescription(reservation) {
      if (!reservation) {
        return null;
      }

      const rule = reservation.property.revenue_share_rule;

      if (!rule) {
        return null;
      }

      let description = reservation.property.revenue_share_rule.description;

      const variables = {
        "{{start_date}}": moment(reservation.start_date).format('DD/MM'),
        "{{end_date}}": moment(reservation.end_date).format('DD/MM'),
        "{{property_name}}": reservation.property.name,
        "{{client_name}}": reservation.client.name,
        "{{res_id}}": reservation.res_id,
      };

      for (const key in variables) {
        description = description.replace(key, variables[key]);
      }

      return description;
    },
    createBillDetailsWithRevenueShare(reservation) {
      const { property, reservation_extras, cleaning_fee, ota_fee, city_tax, revenue_share, total_gross } = reservation;
      const { vat_type, revenue_share_rule } = property;

      const propertyVatValue = 1 + (parseFloat(vat_type.value) / 100);
      const propertyVatType = vat_type.value;
      const revenueRule = revenue_share_rule;
      const groupAmounts = !!revenueRule.group_amounts;

      let amount = 0;
      let billDetails = [];
      let ownerDocumentDetails = [];

      const vatExcluded = {
        //extras: revenueRule.extras_vat_excluded,
        cleaning_fee: revenueRule.cleaning_fee_vat_excluded,
        commission: revenueRule.commission_vat_excluded,
        revenue_share: revenueRule.revenue_share_vat_excluded,
        owner_amount: revenueRule.owner_amount_vat_excluded,
      };

      this.form._options.is_revenue_share = true;
      this.form._options.revenue_share_rule = revenue_share_rule;
      this.form._options.property_owner_id = reservation.property.property_owner_id;

      /**
       * EXTRAS
       */
      if (reservation_extras.length) {
        const extrasDestination = this.$const('ConstRevenueShareDestination', 'PROPERTY_MANAGER');
        if (revenueRule.extras_destination === extrasDestination) {
          amount += reservation_extras.reduce((acc, extra) => {
            const vat = parseInt(extra.vat_percent) >= 0 ? extra.vat_percent : propertyVatType; //vatExcluded.extras ? propertyVatValue : 1;
            const extraAmount = parseFloat(extra.amount) * parseInt(extra.quantity); // * (vat / 100 + 1);
      
            if ((groupAmounts && (extra.vat_percent === propertyVatType || !extra.vat_percent))) {
              return acc + extraAmount;
            } else {
              billDetails.push({
                reservation_id: reservation.id,
                amount: extraAmount,
                vat_type: vat,
                reservation_extra_id: extra.id,
                description: `${reservation.res_id} - ${reservation.client.name} - ${extra.name}`,
                type: this.$const('ConstDetailRowTypes', 'EXTRA')
              });
              return acc;
            }
          }, 0);
        } else {
          ownerDocumentDetails.push({
            reservation_id: reservation.id,
            amount: extraAmount,
            vat_type: 0,
            reservation_extra_id: extra.id,
            description: `${reservation.res_id} - ${reservation.client.name} - ${extra.name}`,
            type: this.$const('ConstDetailRowTypes', 'EXTRA')
          });
        }
      }

      /**
       * CLEANING FEE
       */
      if (cleaning_fee > 0) {
        const cleaningFeeDestination = this.$const('ConstRevenueShareDestination', 'PROPERTY_MANAGER');
        if (revenueRule.cleaning_fee_destination === cleaningFeeDestination) {
          const vat = vatExcluded.cleaning_fee ? propertyVatValue : 1;
          const cleaningFee = parseFloat(cleaning_fee) * vat;

          if (groupAmounts) {
            amount += parseFloat(cleaningFee.toFixed(2));
          } else {
            billDetails.push({
              amount: cleaningFee.toFixed(2),
              vat_type: propertyVatType,
              description: revenueRule.cleaning_fee_description,
              type: this.$const('ConstDetailRowTypes', 'CLEANING_FEE')
            });
          }
        } else {
          ownerDocumentDetails.push({
            amount: parseFloat(cleaning_fee).toFixed(2),
            vat_type: 0,
            description: revenueRule.cleaning_fee_description,
            type: this.$const('ConstDetailRowTypes', 'CLEANING_FEE')
          });
        }
      }

      /**
       * OTAFEE
       */
      if (ota_fee > 0 ) {
        const commissionDestination = this.$const('ConstRevenueShareDestination', 'PROPERTY_MANAGER');
        /**
         * If ota fee will be added to property manager document
         */
        if (revenueRule.commission_destination === commissionDestination) {
          const vat = vatExcluded.commission ? propertyVatValue : 1;
          const otaFee = parseFloat(ota_fee) * vat;

          if (groupAmounts) {
            amount += parseFloat(otaFee.toFixed(2));
          } else {
            billDetails.push({
              amount: otaFee.toFixed(2),
              vat_type: propertyVatType,
              description: revenueRule.commission_description,
              type: this.$const('ConstDetailRowTypes', 'OTA_FEE')
            });
          }
        } else {
          ownerDocumentDetails.push({
            amount: parseFloat(ota_fee).toFixed(2),
            vat_type: propertyVatType,
            description: revenueRule.commission_description,
            type: this.$const('ConstDetailRowTypes', 'OTA_FEE')
          });
        }
      }

      const revenueShareVatExcluded = vatExcluded.revenue_share;
      const vat = revenueShareVatExcluded ? propertyVatValue : 1;
      amount += parseFloat(revenue_share) * vat;

      billDetails.push({
        reservation_id: reservation.id,
        amount: amount.toFixed(2),
        vat_type: propertyVatType,
        description: this.generateDescription(reservation),
        type: this.$const('ConstDetailRowTypes', 'REVENUE_SHARE')
      });

      /**
       * OWNER AMOUNT
       */
      const ownerAmountDestination = this.$const('ConstRevenueShareDestination', 'PROPERTY_MANAGER'); 
      const grandTotal = billDetails.reduce((total, item) => {
        return parseFloat(item.amount) + total;
      }, 0);

      let ownerRow = {};

      if (!vatExcluded.owner_amount) {
        ownerRow = {
          reservation_id: reservation.id,
          amount: (parseFloat(total_gross) - grandTotal).toFixed(2),
          vat_type: propertyVatType,
          description: revenueRule.owner_description,
          type: this.$const('ConstDetailRowTypes', 'OWNER_AMOUNT')
        };
      } else {
        ownerRow = {
          reservation_id: reservation.id,
          amount: (parseFloat(total_gross) - grandTotal).toFixed(2),
          vat_type: 0,
          vat_exclusion_it: this.$const('ConstInvoiceVatExclusionIT', 'N1'),
          description: revenueRule.owner_description,
          type: this.$const('ConstDetailRowTypes', 'OWNER_AMOUNT')
        };
      }

      if (revenueRule.owner_amount_destination === ownerAmountDestination) {
        billDetails.push(ownerRow);
      } else {
        ownerDocumentDetails.push(ownerRow);
      }

      if (city_tax > 0) {
        const cityTaxDestination = this.$const('ConstRevenueShareDestination', 'PROPERTY_MANAGER');
        if (city_tax > 0 && revenueRule.city_tax_destination === cityTaxDestination) {
          billDetails.push({
            amount: parseFloat(city_tax),
            vat_type: 0,
            description: revenueRule.city_tax_description,
            type: this.$const('ConstDetailRowTypes', 'CITY_TAX')
          });
        } else {
          ownerDocumentDetails.push({
            amount: parseFloat(city_tax),
            vat_type: 0,
            description: revenueRule.city_tax_description,
            type: this.$const('ConstDetailRowTypes', 'CITY_TAX')
          });
        }
      }

      this.form.bill_details.push(...billDetails);
      this.form._options.owner_document_details.push(...ownerDocumentDetails);
    },
  }
}
